module.exports = __webpack_public_path__ + "img/handSanitizer.16c9b17f.png";